<template>
  <div class="gallery-filter__header">
    <span class="gallery-filter__filter-message" @click="toggleCategories">
      <span class="gallery-filter__message-icon-wrapper">
        <svg
          class="
            icon
            icon-plus-circle
            gallery-filter__message-icon
            js-filter-message-icon
          "
          aria-hidden="true"
          focusable="false"
        >
          <use xlink:href="#icon-plus-circle"></use>
        </svg>
      </span>
      Filter By
    </span>
    <span class="gallery-filter__information-wrapper">
      <span class="gallery-filter__total-results">
        {{ this.totalResults }}
        {{ +this.totalResults === 1 ? 'Result' : 'Results' }}
        <span
          class="gallery-filter__search-term-display"
          @click="clearSearchTerm"
          v-if="showSearchTerm"
        >
          for "{{ this.searchTerm }}" x
        </span>
      </span>
      <span class="gallery-filter__selected-options">
        <span
          class="gallery-filter__selected-option js-remove-selected-filter"
          v-for="(selectedFilter, index) in selectedFilters"
          :key="selectedFilter.id"
          :data-option-id="selectedFilter"
          @click="toggleOption(selectedFilter)"
        >
          {{ filters[selectedFilter] }} x
          <span
            class="gallery-filter__selected-option-separator"
            v-if="index < Object.keys(selectedFilters).length - 1"
          >
            /
          </span>
        </span>
      </span>
      <span
        class="gallery-filter__clear-all"
        v-if="selectedFilters.length > 0"
        @click="clearFilters"
      >
        Clear All x
      </span>
    </span>
  </div>
</template>

<script>
import { TOGGLE_CATEGORIES, eventBus } from '../shared/event-bus';

export default {
  name: 'GalleryFilterHeader',
  props: ['selectedFilters', 'totalResults', 'filters', 'searchTerm'],
  async mounted() {
    eventBus.$on(TOGGLE_CATEGORIES, data => {
      this.toggleCategories();
    });
  },
  computed: {
    showSearchTerm() {
      return (
        typeof this.searchTerm !== 'undefined' && this.searchTerm.length > 2
      );
    },
  },
  methods: {
    toggleOption(optionID) {
      let selector = `.js-resources-filter-option[data-id="${optionID}"] input[type=checkbox]`;
      document.querySelector(selector).click();
    },
    toggleCategories() {
      // "xl" cutoff in tailwind.js is 1200px
      if (window.innerWidth >= 1200) return;

      // TODO: Rename this class because the "clear all" button for mobile has
      // the same class name (it is not an option category).
      const elements = document.querySelectorAll(
        '.js-option-category, .js-filter-header'
      );

      // This gets set many times in the loop, but it should always be set to
      // the same value anyway.
      let hiding;
      elements.forEach(element => {
        hiding = element.style.display === 'block';

        if (hiding) {
          element.style.display = 'none';
        } else {
          element.style.display = 'block';
        }
      });

      const mobileButtons = document.querySelector('.js-mobile-buttons');
      if (mobileButtons !== null) {
        if (hiding) {
          mobileButtons.style.display = 'none';
        } else {
          mobileButtons.style.display = 'flex';
        }
      }

      const svg = document.querySelector('.js-filter-message-icon');
      if (hiding) {
        svg.style.transform = '';
      } else {
        svg.style.transform = 'rotate(135deg)';
      }
    },
    clearFilters() {
      eventBus.clearAllFilters();
    },
    clearSearchTerm() {
      eventBus.refreshSearch();
    },
  },
};
</script>
